<span class="overline">3D VIEW SETTINGS</span>

<h3-view-settings-opacity-slider
  [defaultLayerOpacity]="defaultLayerOpacity"
  [layerOpacityStore]="layerOpacityStore"
></h3-view-settings-opacity-slider>

<h3-view-settings-slider
  [defaultValue]="defaultPointSize"
  [config]="pointSizeConfig"
  [settingStore]="pointSizeStore"
  label="Point size"
  settingName="point_size"
  suffix="px"
></h3-view-settings-slider>

@if (hasGroundingSettingsFeatureFlag) {
  <mat-divider></mat-divider>
  <h3-grounding-settings></h3-grounding-settings>
}

<mat-divider class="color-divider"></mat-divider>
<h3-point-color-settings></h3-point-color-settings>

<mat-divider></mat-divider>
<h3-persist-checkbox></h3-persist-checkbox>
